module.exports = __webpack_public_path__ + "static/img/irole.8d4311d.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/tsz/irole.png
// module id = U34K
// module chunks = 7